<template>
  <div class="PosterManagement spackage padding-20 bgc box-shadow">

    <div class="title"><p>活动名称: <span>{{ title }}</span></p></div>

    <div class="poster-list">
        <div class="poster-item" v-for="item in posterTable">
            <div class='img'>
                <img :src="item.coveratturlid">
            </div>
            <div>
                <span class='poster-footer' v-if="status != 100 && status != 30">
                    <el-button type="primary" class="btncolor-1" @click="goto('PosterSetup',item.innerid)">编辑</el-button>
                    <el-button type="primary" class="btncolor-2" @click="del(item.innerid)">删除</el-button>
                </span>
            </div>
        </div>
        <div  v-if="status != 100 && status != 30" class="add" @click="goto('PosterSetup')">+</div>
    </div>
    <el-button @click="back()" style="margin-top: 20px;margin-left: 30px">返回</el-button>
  </div>
</template>

<script>
import {getAssEventPosterList, deleteAssEventPoster} from 'api/taskToolsApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: "PosterManagement",
    data() {
        return {
            eventinnerid: this.$route.query.eventinnerid,   // 活动id
            posterTable: [],    // 列表
            title: this.$route.query.title, // 名称
            status: '',
        }
    },
    mounted() {
        // 海报列表
        this.getAssEventPosterList()
    },
    methods: {

        goto(name, innerid) {
            this.$router.push({name: name, query: {eventinnerid: this.eventinnerid, innerid: innerid}})
        },

        back() {
            this.$router.go(-1)
        },
        del(innerid) {  // 删除海报
            this.$confirm('您确定删除海报？','提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                
                this.setLoading(true)
                deleteAssEventPoster({
                    data: {eventinnerid: this.eventinnerid, innerid: innerid},
                    success: data => {
                        this.$message.success('删除成功')
                        this.setLoading(false)
                        // 刷新
                        this.getAssEventPosterList()
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })

            }).catch(() => {})
        },
        getAssEventPosterList() {   // 海报列表
            
            this.setLoading(true)
            getAssEventPosterList({
                data: {'eventinnerid': this.eventinnerid},
                success: data => {

                    this.setLoading(false)
                    this.posterTable = data.data.content

                    this.status = data.data.eventstatus

                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
                
            })

        },
        ...mapActions(['setLoading'])
    }

}
</script>

<style lang="scss" type="text/scss">
    .PosterManagement {
        .title {
            padding: 20px 0;
            border-bottom: solid 1px #DCDFE6;
            p,
            span {
                font-size: 16px;
            }
            p {
                padding-left: 20px;
                border-left: solid 2px #409EFF;
                color: #303133;
            }
            span {
                color: #909399;
            }
        }

        .poster-list {
            margin-top: 20px;
            overflow: hidden;
           
            .poster-item {
                display: block;
                float: left;
                margin-left: 30px;
                height: 280px;

                .img {
                    margin-bottom: 10px;
                    width: 135px;
                    height: 240px;
                    border: solid 1px #eee;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .btncolor-1,
            .btncolor-2 {
                min-width: 60px;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                border-color: #409EFF;
            }
            .btncolor-1 {
                margin-left: 5px;
                background: #67C23A
            }
            .btncolor-2 {
                background: #F56C6C
            }
        }
        .add {
            float: left;
            margin-left: 30px;
            cursor: pointer;
            width: 135px;
            height: 240px;
            border: solid 1px #979797; 
            font-size: 32px;
            color: #909399;
            font-weight: bold;
            line-height: 240px;
            text-align: center;
        }
        .add:hover {
            color: #409EFF;
            border-color: #409EFF;
        }
    }
</style>